module.exports = __webpack_public_path__ + "img/format_italic.9b8afb07.svg";